import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";

import { observer } from "mobx-react-lite";

import "./style.css";
import { Box, Divider, Typography } from "@mui/material";
import { Error, CheckCircle } from "@mui/icons-material";
import { IconType, notifierStore } from "src/framework/store/NotifierStore";
import { FlatButton, FlatButtonProperties } from "src/framework/components/buttons/FlatButton";

const button: FlatButtonProperties = {
  text: "Ok",
  color: "primary",
  variant: "contained",
  onClick: () => notifierStore.getOnClose(),
};

const buttonClose: FlatButtonProperties = {
  text: "FECHAR",
  color: "secondary",
  variant: "outlined",
  onClick: () => notifierStore.getOnClose(),
};

const submitButton: FlatButtonProperties = {
  text: "WHATSAPP",
  color: "primary",
  variant: "contained",
  onClick: () => notifierStore.getOnSubmit(),
};

const renderIcon = (icon: IconType) => {
  const icons = {
    error: <Error color="error" />,
    warning: <Error style={{ color: '#CC8F00' }} />,
    success: <CheckCircle color='primary' />
  }
  return icons[icon]
}

const Notifier = observer(() => {
  return (
    <div>
      <Dialog open={notifierStore.getOpen()} style={{ minWidth: "300px" }}>
        <div
          onMouseEnter={() => notifierStore.onMouseEnter()}
          id="notifier-container"
        >
          {notifierStore.getShowProgress() ? (
            <LinearProgress
              id="timeout-progress"
              variant="determinate"
              value={notifierStore.getPercent()}
            />
          ) : (
            ""
          )}
          <DialogTitle id="simple-dialog-title">
            <Box display='flex' justifyContent={"space-between"} alignItems="center">
              <Box display='flex' flexDirection={"column"}>
                {notifierStore.getTitle()}
                <Typography variant={'body2'} color="textSecondary">
                  {notifierStore.subtitle}
                </Typography>
              </Box>
              {notifierStore.iconType && renderIcon(notifierStore.iconType)}
            </Box>
          </DialogTitle>
          
          <Divider />
          
          <DialogContent style={{ minWidth: "300px" }}>
            <DialogContentText id="alert-dialog-description">
              {Array.isArray(notifierStore.getContent())
                ? [...notifierStore.getContent()].flat().map(
                  (msg: string, index: number) => {
                    return (
                      <>
                        <div dangerouslySetInnerHTML={{ __html: typeof msg === 'string' || React.isValidElement(msg) ? msg : 'Ocorreu um erro inesperado.' }} />
                      </>
                    );
                  }
                )
                : typeof notifierStore.getContent() === 'string' || React.isValidElement(notifierStore.getContent())
                  ? notifierStore.getContent()
                  : 'Ocorreu um erro inesperado.'}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            { !notifierStore.haveOnsubmit() && (
                <FlatButton {...button} />
              )
            }
            { notifierStore.haveOnsubmit() && (
                <>
                  <FlatButton {...buttonClose} />
                  <FlatButton {...submitButton} />
                </>
              )
            }
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
});

export { Notifier };
